import React from "react";

function Home() {

    return (
        <div className="card">
            <div className="card-body overflow-hidden p-lg-6">
                <div className="row align-items-center">
                    <div className="col-lg-4"><img className="img-fluid" src="assets/img/icons/spot-illustrations/21.png" alt="" /></div>
                    <div className="col-lg-8 ps-lg-4 my-5 text-center text-lg-start">
                        <h3 className="text-primary"><small>Welcome to</small> <br />Synergy Oil Trade Optimizer!</h3>
                        <p className="lead">Unlock the potential of the global oil market with 
                            Synergy Oil Trade Optimizer <b className="text-primary">(SotPro)</b>, your comprehensive platform for trading crude oil. 
                            It provides you with the tools and insights 
                            you need to make informed trading decisions.</p>
                        <a className="btn btn-falcon-primary" href="#/">Getting started</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
